
let mode = localStorage.getItem("mode"); // "some_value"

const Layout1Settings = {
  leftSidebar: {
    show: true,
    mode: "full", // full, close, compact, mobile,
    theme: "caaDark", // View all valid theme colors inside MatxTheme/themeColors.js
  },
  topbar: {
    show: true,
    fixed: true,
    theme: mode === "dark" ? "caaDark" : "caaLight", // View all valid theme colors inside MatxTheme/themeColors.js
  }
};

export default Layout1Settings;
